<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	import { postReq } from '../../../../services/http';
	//Stores
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, toast } from '@Shelly/shelly-design-system';

	export let device;

	let loading = false;

	$: statusStore = getDeviceStatus(device?.id);
	$: disabled = $statusStore?.gas_sensor?.self_test_state === 'running';

	const beginSelfTest = async () => {
		loading = true;
		//Self test only can be enabled, there is no stop method
		const res = await postReq(`/device/sensor/gas_sensor_test`, {
			id: device.id,
			enable: 1,
		});

		if (res.isok) {
			toast.open({
				type: 'info',
				title: $format('self_test_scc_toast', {
					default: 'Self test started.',
				}),
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
		loading = false;
	};
</script>

<Button size="m" {loading} {disabled} on:click={beginSelfTest}>{$format('button_self_test')}</Button>
